import Vue from 'vue'

import { copyText, imgFilter } from '@/utils'
import { toast } from '@/components/toast'

export default () => {
  Vue.use({
    install: (Vue) => {
      Vue.directive('copy', function(el, bind) {
        const { value } = bind
        const flag = el.vCopyText
        if (flag) return
        const hasValue = Array.isArray(value) && value[0]
        if (!hasValue) return
        el.vCopyText = true
        el.addEventListener(
          'click',
          () => {
            copyText(value[0])
              .then(() => {
                // 复制成功
                value[1] && toast(value[1])
              })
              .catch(() => {
                // 复制失败
                value[2] && toast(value[2])
              })
          },
          false
        )
      })
      Vue.directive('imgFilter', function (el, bind) {
        // console.log(el, bind);
        // el.src = bind.value.url + imgFilter('', bind.modifiers.w, bind.modifiers.h)
      })
    }
  })
}
